export const LOGO = "/new-logo/logo.png";

export const ICON = "/new-logo/icon.png";

export const LOGO_XL = "/new-logo/logo.png";

/** Light wordmark for dark surfaces (sidebar). */
export const LOGO_LIGHT = "/new-logo/logo-light.png";

// Sidebar logo assets from local public directory
export const SIDEBAR_LOGO_ICON = "/new-logo/icon.png";
export const SIDEBAR_LOGO_WORDMARK = "/new-logo/logo-light.png";

// Dashboard assets
export const ANALYTICS_CHART_ICON = "/chart 1.svg";
export const LINKEDIN_ONBOARDING_ICON = "/linkedin 1.svg";
export const CAMPAIGN_ONBOARDING_ICON = "/fi_2314257.svg";
